class VehicleGnc {
    constructor(enabled = false, message = '', value = {}) {
        this.enabled = enabled
        this.message = message
        this.value = {
            min: value?.min ?? null,
            max: value?.max ?? null,
            step: value?.step ?? null,
        }
    }

    static fromJson(json = {}) {
        const { enabled = false, message = '', value = {} } = json
        return new VehicleGnc(enabled, message, value)
    }
}

export default VehicleGnc